/**
 *
 * @param valueString - The string to be parsed
 * @returns Extracted message content if available, otherwise returns the original string
 */
export const extractMessageContent = (valueString: string, replace: boolean = false): string => {
  try {
    const parsed: unknown = JSON.parse(valueString);
    if (parsed && typeof parsed === 'object' && 'messageContent' in parsed) {
      const messageContent = (parsed as { messageContent: string }).messageContent;
      if (replace) {
        return messageContent.replace(/\n/g, '<br>');
      }
      return messageContent;
    }
  } catch {
    return valueString;
  }
  return valueString;
};

export const normalizePhoneNumber = (phone: string | number | null | undefined): string => {
  if (!phone) return '';
  let normalized = String(phone).trim();
  normalized = normalized.replace(/\D/g, '');
  normalized = normalized.replace(/^0+/, '');

  if (normalized.startsWith('1') && normalized.length >= 11) {
    normalized = normalized.slice(1);
  }

  return normalized;
};

export const normalizePhoneNumberDashed = (normalized: string | undefined): string => {
  if (!normalized) return '';
  const dashed = `${normalized.slice(0, 3)}-${normalized.slice(3, 6)}-${normalized.slice(6)}`;

  return dashed;
};

export const normalizePhoneNumberParenthesized = (normalized: string | undefined): string => {
  if (!normalized) return '';
  const parenthesized = `(${normalized.slice(0, 3)}) ${normalized.slice(3, 6)}-${normalized.slice(6)}`;

  return parenthesized;
};
